module.exports = __webpack_public_path__ + "img/blog-list-sidebar-light.87e47855.png";